"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateLocation = exports.locationChange = exports["default"] = exports.LOCATION_CHANGE = void 0;
var LOCATION_CHANGE = 'LOCATION_CHANGE';
exports.LOCATION_CHANGE = LOCATION_CHANGE;

var locationChange = function locationChange() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  return {
    type: LOCATION_CHANGE,
    payload: location
  };
};

exports.locationChange = locationChange;

var updateLocation = function updateLocation(_ref) {
  var dispatch = _ref.dispatch;
  return function (nextLocation) {
    return dispatch(locationChange(nextLocation));
  };
};

exports.updateLocation = updateLocation;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return action.type === LOCATION_CHANGE ? action.payload : state;
};

exports["default"] = _default;